import { FC } from "react";
import { Box, List, Paper, Stack } from "@mui/material";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import __ from "src/utils/Translations";
import EmployeeDetails from "src/Pages/Company/Absences/EmployeeDetails";
import EmployeeCardListItem from "src/Pages/Company/Absences/EmployeeCard/EmployeeCardListItem";
import { IEmployeeDetails } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";

interface IEmployeeCardProps {
  data?: IEmployeeDetails;
}

const EmployeeCard: FC<IEmployeeCardProps> = ({ data }) => {
  if (!data) return null;

  const listData = [
    {
      icon: <DraftsOutlinedIcon />,
      text: data.email,
    },
    {
      icon: <PhoneAndroidIcon />,
      text: data.phone,
    },
    {
      icon: <LocationOnOutlinedIcon />,
      text: data.localization,
    },
  ];

  return (
    <Paper
      sx={{ padding: "1.5rem", mb: "2rem" }}
      data-testid="absences-employee-card"
    >
      <Stack direction="row" spacing={4} alignItems="center">
        <Box flexBasis="50%">
          <EmployeeDetails data={data} showFk />
        </Box>
        <Box flexBasis="50%">
          <List dense>
            {listData.map(
              ({ icon, text }) =>
                text && (
                  <EmployeeCardListItem key={text} text={text} icon={icon} />
                )
            )}
          </List>
        </Box>
      </Stack>
    </Paper>
  );
};

export default EmployeeCard;
